import * as React from 'react';
import { STATE } from 'app/constants';
import { containerFactory, DefaultContainerProps } from 'app/infrastructure/redux';
import { Dialog } from './dialog';
import { signin } from 'app/infrastructure/auth/token-manager';
import { ButtonPrimary } from 'ui';
import { FaSyncAlt } from 'react-icons/fa';

import styles from './auth.scss';

type LoginFailedProps = DefaultContainerProps;

export class LoginFailedComponent extends React.Component<LoginFailedProps, any> {
  public static statePath: string = STATE.app;

  private onClickTryAgain = () => {
    signin(true, true);
  };

  public render() {
    return (
      <Dialog>
        <div>
          <div className={`${styles.iconAsBg} ${styles.errorIcon}`}/>
          <h1>{this.props.translation.loginFailTitle}</h1>
          <p>{this.props.translation.loginFailBody}</p>

          <div className={`${styles.buttonWrapper}`}>
            <ButtonPrimary onClick={this.onClickTryAgain} icon={FaSyncAlt}>
              {this.props.translation.loginFailRefresh}
            </ButtonPrimary>
          </div>
        </div>
      </Dialog>
    );
  }
}

const container = containerFactory(LoginFailedComponent, null);

export { container as LoginFailed };
